// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_e7-3";
export var flatBottomCorners = "_e7-5";
export var productImage = "_e7-0";
export var quantityContainer = "_e7-2";
export var quantityHeader = "_e7-6";
export var tooltip = "_e7-1";
export var wrapAndEllipsesOverflow = "_e7-4";